<script lang="ts" setup>
import { computed, useAttrs } from 'vue';

const attrs = useAttrs();

// VSelect puts role="combobox" on the field wrapper, while an aria-label handed to the select
// lands on the <input> inside it — so the combobox itself stays unnamed and fails 4.1.2. The menu
// binds its activatorProps onto that same wrapper, which is the one way to reach it from outside.
const menuProps = computed(() => ({
  class: ['hero-select-list'],
  activatorProps: { 'aria-label': attrs['aria-label'] as string | undefined },
}));
</script>

<template>
  <v-select v-on="$attrs" class="hero-select" rounded="lg" :menu-props="menuProps" hide-details single-line> </v-select>
</template>

<style lang="scss">
@use 'sass:map';
@use 'vuetify/settings';
.hero-select-list {
  .v-overlay__content.v-select__content {
    & .v-list {
      .v-list-item {
        & .v-list-item__content {
          padding-left: map.get(settings.$spacers, 3); // vue-3
        }
        & .v-list-item__prepend {
          width: 24px;
          height: 24px;
          &::after {
            position: relative;
            top: 0;
            left: 0;
            width: 24px;
            min-height: 24px;
            content: '';
          }
        }
      }
      & .v-list-item--active {
        & .v-list-item__prepend {
          &::after {
            position: relative;
            top: 0;
            left: 0;
            width: 24px;
            min-height: 24px;
            mask: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21 6.99984L9 18.9998L3.5 13.4998L4.91 12.0898L9 16.1698L19.59 5.58984L21 6.99984Z" fill="%23494D50"/></svg>')
              no-repeat 0 0/24px 24px;
            transition: background-color 1s;
            background-color: rgb(var(--v-theme-on-surface-medium));
            content: '';
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scope>
@use 'sass:map';
@use 'vuetify/tools';
@use 'vuetify/settings';

.hero-select {
  // make background color trnsparent for on mobilish devices
  .v-input__control {
    @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
      .v-field {
        background-color: transparent !important;
      }
    }

    & .v-field--variant-solo {
      background-color: rgb(var(--v-theme-secondary-container));

      & .v-field__prepend-inner {
        background-color: rgb(var(--v-theme-secondary));

        height: 100%;
        aspect-ratio: 1 / 1;
        margin-left: -12px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        border-radius: inherit;
        color: rgb(var(--v-theme-on-secondary));

        > .v-icon {
          opacity: 1;
        }
      }

      & .v-field__field {
        padding-left: map.get(settings.$spacers, 3); // vue-3
        padding-right: map.get(settings.$spacers, 3); // vue-3
        > .v-field-label,
        > .v-field__input {
          padding: 0px;
          margin: 0px;

          input {
            align-self: center;
          }
        }
      }

      & .select-prepend-inner-icon-container {
        width: 100px;
        height: 100%;
      }
    }
  }
}
</style>
